export default __webpack_public_path__ + "static/media/logout.9d4a8a06.svg";